const entities = {
  fieldLibrary: "Библиотека полей",
  fieldLibraryDesc: "Глобальные поля для повторного использования",
  entityTypes: "Типы сущностей",
  entityTypesDesc: "Шаблоны, определяющие поля для каждого типа записи",
  newField: "Новое поле",
  editField: "Редактировать поле",
  newType: "Новый тип",
  editType: "Редактировать тип",
  metaKey: "Мета-ключ",
  fieldType: "Тип поля",
  category: "Категория",
  composite: "Составное",
  subFields: "Подполя",
  addSubField: "Добавить подполе",
  displayTemplate: "Шаблон отображения",
  options: "Опции",
  addOption: "Добавить опцию",
  label: "Метка",
  labelHe: "Метка (иврит)",
  labelEn: "Метка (английский)",
  fields: "полей",
  usedIn: "Используется в",
  allCategories: "Все категории",
  allTypes: "Все типы",
  searchFields: "Поиск полей...",
  searchTypes: "Поиск типов сущностей...",
  noFieldsFound: "Поля не найдены",
  cancel: "Отмена",
  save: "Сохранить",
  create: "Создать",
  slug: "Идентификатор",
  icon: "Иконка",
  color: "Цвет",
  defaultView: "Вид по умолчанию",
  registryKind: "Тип реестра",
  registryKindHint: "מאגר (реестр) = операционная запись, создаётся/редактируется здесь · ספריה (библиотека) = компонент дизайн-системы · קטלוג (каталог) = внешний справочник, только чтение",
  registryKindOptions: { "מאגר": "מאגר — Операционная запись", "ספריה": "ספריה — Компонент дизайн-системы", "קטלוג": "קטלוג — Внешний справочник (только чтение)" },
  selectFields: "Выбрать поля",
  inheritedFrom: "унаследовано от ",
  inheritedFieldsHint: "Поля с пометкой «унаследовано» приходят от родительского типа и не хранятся в этом типе",
  selectGroups: "Выбрать повторяющиеся группы",
  connections: "Связи",
  sourceType: "Источник",
  targetType: "Цель",
  relationLabel: "Метка связи",
  add: "Добавить",
  viewNotes: "Просмотр записей",
  views: { table: "Таблица", board: "Доска", list: "Список", calendar: "Календарь", gantt: "Гантт", timeline: "Хронология", gallery: "Галерея", stream: "Поток" },
  searchNotes: "Поиск записей...",
  newNote: "Новая запись",
  records: "записей",
  filter: "Фильтр",
  contains: "Содержит",
  isEmpty: "Пусто",
  isNotEmpty: "Не пусто",
  addFilter: "Добавить фильтр",
  prev: "Назад",
  next: "Далее",
  loading: "Загрузка...",
  entityNotFound: "Тип сущности не найден",
  versionConflict: "Не сохранено — запись могла измениться после открытия. Данные обновлены, попробуйте снова",
  linkedNotes: "Связанные записи",
  link: "Связать",
  searchToLink: "Поиск записи для связывания...",
  stakeholders: "Заинтересованные стороны",
  addStakeholder: "Добавить участника",
  searchContact: "Поиск контакта...",
  primary: "Основные",
  additional: "Дополнительные",
  access: "Доступ",
  notify: "Уведомления",
  role: "Роль",
  activity: "Активность",
  comment: "Комментарий",
  callLog: "Звонок",
  showInactive: "Показать неактивные",
  hideInactive: "Скрыть неактивные",
  deactivate: "Деактивировать",
  reactivate: "Активировать",
  inactive: "Неактивный",
  zoom: "Масштаб",
  day: "День",
  week: "Неделя",
  month: "Месяц",
  noGanttData: "Нет данных для диаграммы Гантта",
  noTimelineData: "Нет данных для хронологии",
  devTask: "Задача разработки",
  deal: "Сделка",
  lead: "Лид",
  agreement: "Соглашение",
  kpiEvents: "KPI события",
  activityLog: "Журнал активности",
  backToList: "Назад к списку",
  lastEdited: "Изменено",
  createdAt: "Создано",
  confirmDelete: "Удалить навсегда?",
  actions: {
    allActions: "Все действия",
    deactivate: "Деактивировать",
    reactivate: "Активировать",
    changeStatus: "Изменить статус",
    exportCsv: "Экспорт CSV",
    openInAi: "Открыть в AI",
    sendNotification: "Отправить уведомление",
    callLog: "Журнал звонков",
    sendWhatsapp: "Отправить WhatsApp",
    confirmDeactivate: "Деактивировать эту запись?",
    confirmBulkDeactivate: "Деактивировать выбранные записи?",
    bulkSelected: "выбрано",
    noActions: "Нет доступных действий",
    bulkStatusChange: "Массовое изменение статуса",
    bulkAssignTitle: "Массовое назначение",
    assigneePlaceholder: "Имя исполнителя...",
    applyAssign: "Применить назначение",
    noStatusOptions: "Нет вариантов статуса",
  },
  bulk: {
    title: "Массовое обновление поля",
    stepField: "Выбрать поле",
    stepValue: "Установить значение",
    stepPreview: "Предпросмотр",
    settingValueFor: "Установка значения для",
    next: "Далее",
    apply: "Применить изменения",
    recordsAffected: "записей будет затронуто",
    record: "Запись",
    currentValue: "Текущее",
    newValueLabel: "Новое значение",
    more: "ещё",
  },
  saveFailed: "Ошибка сохранения",
  tabGeneral: "Общее",
  tabTemplate: "Шаблон",
  templates: "Шаблоны",
  addTemplate: "Добавить шаблон",
  browseTemplates: "Обзор шаблонов",
  linkedTemplates: "Связанные шаблоны",
  openFullEditor: "Открыть в редакторе",
  noTemplates: "Нет шаблонов",
  linkTemplate: "Связать шаблон",
  unlinkTemplate: "Отвязать",
  createTemplate: "Создать новый шаблон",
  accessDenied: "Доступ запрещён",
  adminOnly: "Действие доступно только администраторам",
  roleAdmin: "Администратор",
  roleManager: "Менеджер",
  roleMember: "Участник",
  roleViewer: "Наблюдатель",
  roleExternal: "Внешний",
  savedViews: "Сохранённые виды",
  saveView: "Сохранить вид",
  viewName: "Название вида",
  deleteView: "Удалить вид",
  noSavedViews: "Нет сохранённых видов",
  savedViewPrivate: "Только я",
  savedViewsLoadFailed: "Не удалось загрузить сохранённые виды",
  viewSaveFailed: "Не удалось сохранить вид",
  viewDeleteFailed: "Не удалось удалить вид",
  viewSaved: "Вид сохранён",
  viewDeleted: "Вид удалён",
  allRecords: "Все записи",
  aliases: "Альтернативные имена",
  addAlias: "Добавить псевдоним",
  noAliases: "Нет псевдонимов",
  mergeField: "Объединить с полем",
  mergeWarning: "Старый ключ станет псевдонимом — данные не пострадают",
  autoGenerated: "Сгенерировано",
  aliasSource: "Источник",
  aliasManual: "Вручную",
  aliasMerged: "Объединено",
  fieldMerged: "Поле успешно объединено",
  groupByCategory: "Группировать",
  flatList: "Плоский список",
  confirmDeleteField: "Удалить это поле?",
  fieldUsedWarning: "Это поле используется. Удаление может привести к потере данных",
  tryDifferentSearch: "Попробуйте другие ключевые слова",
  noFieldsYet: "Полей пока нет",
  createFirstField: "Создать первое поле",
  validation: "Валидация",
  required: "Обязательное",
  uniqueValue: "Уникальное значение",
  patternRegex: "Шаблон (Regex)",
  defaultValue: "Значение по умолчанию",
  noDefault: "Нет значения",
  dragToReorder: "Перетащите для сортировки",
  descriptionHe: "Описание (иврит)",
  descriptionEn: "Описание (английский)",
  clientDisplayNameHe: "Имя для клиента (иврит)",
  clientDisplayNameEn: "Имя для клиента (английский)",
  clientDisplayNameHint: "Имя, которое клиент увидит в формах и личном кабинете. По умолчанию: название поля",
  storyCardRefs: "Карточки Story Map",
  noStoryCardRefs: "Нет связанных карточек",
  viewInStoryMap: "Посмотреть в Story Map",
  systemFields: "Системные поля",
  systemField: "Системное поле",
  systemFieldLocked: "Системное поле — нельзя удалить",
  universalFields: "Универсальные поля",
  valuesWithoutField: "Значения без поля",
  viewCards: "Карточки",
  viewList: "Список",
  viewCompact: "Таблица",
  fieldInfo: "Информация о поле",
  fieldPurpose: "Назначение",
  fieldUsage: "Использование",
  fieldSettings: "Настройки",
  optionsCount: "Опции",
  hasValidation: "Валидация",
  hasColorRules: "Цветовые правила",
  hasVisibilityRules: "Правила видимости",
  isReadOnly: "Только чтение",
  noDescription: "Нет описания",
  totalFields: "Всего полей",
  searchByAll: "Поиск по имени, ключу, описанию, категории...",
  tabSystem: "Системные поля",
  tabLibrary: "Библиотека полей",
  systemFieldsInfo: "Системные поля встроены и автоматически применяются к каждой сущности. Их нельзя удалить или редактировать.",
  libraryFieldsInfo: "Создавайте новые поля и управляйте библиотекой. Эти поля доступны при создании типов сущностей.",
  tips: {
    validation: "Валидация = правила данных. Определяет обязательность, уникальность и формат значения.",
    required: "Обязательное = должно иметь значение. Запись нельзя сохранить без этого поля.",
    unique: "Уникальное = одно значение не может повторяться. Например: ИНН, номер счёта.",
    pattern: "Шаблон (Regex) = формат, которому должно соответствовать значение.",
    minMax: "Мин / Макс = допустимый диапазон значения. Для чисел: числовое значение. Для текста: мин/макс длина символов.",
    metaKey: "Мета-ключ = технический ID поля в БД. Создаётся автоматически.",
    fieldType: "Тип поля определяет какие данные можно вводить: текст, число, выбор, дата и т.д.",
    category: "Категория = логическая группировка полей для удобного поиска.",
    composite: "Составное поле = содержит подполя. Например: адрес с улицей, городом, индексом.",
    options: "Опции = список вариантов для поля выбора. Каждый с именем и цветом.",
    aliases: "Псевдонимы = альтернативные ключи для того же поля.",
    visibilityRules: "Правила видимости = когда показывать поле.",
    colorRules: "Цветовые правила = динамический цвет фона по значению.",
    readOnly: "Только чтение = поле нельзя редактировать вручную.",
    defaultValue: "Значение по умолчанию = автозаполнение при создании записи.",
    description: "Описание = объяснение назначения поля.",
    icon: "Иконка = визуальный символ поля.",
    merge: "Объединение = слияние двух полей в одно.",
    sortOrder: "Порядок = позиция поля в списке.",
    entityType: "Тип сущности = 'линза' определяющая какие поля показывать.",
    templateConfig: "Шаблон = макет, виды, кнопки действий, KPI.",
    connections: "Связи = отношения между типами сущностей.",
    fieldGroups: "Повторяющиеся группы = набор полей, который повторяется.",
  },
  activityLabels: { field_change: "Поле изменено", status_change: "Статус изменён", comment: "Комментарий", call_log: "Звонок", relation_added: "Связь добавлена", relation_removed: "Связь удалена", stakeholder_added: "Участник добавлен", stakeholder_removed: "Участник удалён", created: "Создано", deactivated: "Деактивировано", reactivated: "Активировано", deleted: "Удалено" },
  timeNow: "сейчас",
  timeMinutesAgo: "{n} мин. назад",
  timeHoursAgo: "{n} ч. назад",
  timeDaysAgo: "{n} дн. назад",
  addCommentPlaceholder: "Добавить комментарий...",
  callSummaryPlaceholder: "Итог звонка...",
  noActivityYet: "Нет активности",
  comments: { title: "Комментарии", reply: "Ответить", edit: "Редактировать", delete: "Удалить", edited: "(изменено)", deleteConfirm: "Удалить?", writeComment: "Написать комментарий...", noComments: "Комментариев пока нет", replyingTo: "Ответ на...", justNow: "сейчас", reactions: "Реакции" },
  notifyAll: "Все",
  notifyMilestones: "Вехи",
  notifyMentions: "Упоминания",
  notifyNone: "Нет",
  noStakeholdersYet: "Нет заинтересованных сторон",
  tabOptions: "Опции",
  tabValidation: "Валидация",
  tabVisibility: "Видимость",
  tabColors: "Цвета",
  tabAliases: "Псевдонимы",
  readOnlyField: "Поле только для чтения",
  visibilityRulesLabel: "Правила видимости",
  visibilityRulesDesc: "Поле отображается только при выполнении всех условий. Скрытые обязательные поля не проверяются.",
  addCondition: "Добавить правило",
  fieldAlwaysVisible: "Поле всегда отображается (нет условий)",
  valuePlaceholder: "Значение",
  colorRulesLabel: "Цветовые правила",
  colorRulesDesc: "Цвет поля меняется по условиям. Применяется первое подходящее правило.",
  addColorRule: "Добавить правило",
  noColorRules: "Нет цветовых правил (стиль по умолчанию)",
  addRow: "Добавить строку",
  setupGuide: "Руководство по настройке",
  stepByStep: "Шаг за шагом",
  openLink: "Открыть",
  templateNamePlaceholder: "Название шаблона...",
  noTimelineDataDisplay: "Нет данных для хронологии",
  noStreamDataDisplay: "Пока нет активности",
  noDateFieldDefined: "Нет поля даты для этой сущности",
  tabGeneralType: "Общее",
  tabTemplateType: "Шаблон",
  titleColumn: "Заголовок",
  noRecords: "Нет записей",
  noGanttDataDisplay: "Нет данных для диаграммы Гантта",
  ganttZoom: "Масштаб",
  ganttDay: "День",
  ganttWeek: "Неделя",
  ganttMonth: "Месяц",
  boardAll: "Все",
  boardNone: "Нет",
  boardHideEmpty: "Скрыть пустые колонки",
  columnBrowser: "Браузер колонок",
  noStatusFieldFound: "Поле статуса не найдено",
  callSummaryActionPlaceholder: "Итог звонка...",
  noConnectionsDefined: "Нет определённых связей",
  connectionDiagram: "Диаграмма связей",
  linksCount: "связей",
  relations: "Связи",
  addRelation: "Добавить связь",
  searchToLinkRelation: "Поиск сущности для связывания...",
  noRelations: "Нет связей",
  removeRelation: "Удалить связь",
  linkedEntities: "Связанные сущности",
  bulkBar: {
    nSelected: "выбрано",
    updateStatus: "Изменить статус",
    updateField: "Обновить поле",
    deactivate: "Деактивировать",
    delete: "Удалить",
    confirmDelete: "Удалить выбранные записи?",
    confirmDeactivate: "Деактивировать выбранные записи?",
    apply: "Применить",
    success: "Действие выполнено успешно",
    selectField: "Выбрать поле",
    enterValue: "Введите значение...",
    partial: "Выполнено: {ok}, не удалось: {failed}",
    allFailed: "Действие не выполнено — записи не изменены",
  },
  entityCanvas: {
    frame: "Рамка",
    linkGraph: "Граф связей",
    navLog: "Лог навигации",
    addBlock: "Добавить блок",
    emptyCanvas: "Перетащите блоки сюда — папки, поля, группы, плагины",
    emptyGraph: "Граф связей сущности отобразится здесь",
    emptyHistory: "История навигации пуста",
    noRelations: "Связей пока нет",
    title: "Название",
    type: "Тип",
    time: "Время",
    newBlock: "Новый блок",
    folder: "Папка",
    field: "Поле",
    fieldGroup: "Группа полей",
    note: "Заметка",
    plugin: "Плагин",
    pickBlockType: "Выберите тип блока",
    pickField: "Выберите поле",
    comingSoon: "Скоро",
    linkedEntities: "Связанные сущности",
    noLinked: "Нет связанных сущностей",
    whiteboard: "vCanvas",
  },
  csvImport: {
    importCsv: "Импорт CSV",
    uploadTitle: "Загрузка CSV",
    uploadDesc: "Перетащите CSV файл или нажмите для выбора",
    dropHere: "Отпустите файл здесь",
    browse: "Обзор",
    fileSelected: "Файл выбран",
    rowCount: "строк",
    mapFields: "Сопоставление полей",
    csvColumn: "Столбец CSV",
    entityField: "Поле сущности",
    skipColumn: "-- Пропустить --",
    autoMapped: "Авто-сопоставление",
    preview: "Предпросмотр",
    importButton: "Импорт",
    importing: "Импортирование...",
    importComplete: "Импорт завершён успешно",
    importError: "Ошибка импорта",
    step1: "Загрузка",
    step2: "Сопоставление",
    step3: "Импорт",
  },
} as const;
export default entities;
